import endpoints from "../data/endpoints";
import {
	LoadSubmissionResponse,
	SavedSubmissionPayload,
	SaveSubmissionResponse,
} from "../types/types";
import apiRequest from "./apiRequest";

export const saveSubmission = async (
	data: SavedSubmissionPayload,
	uuid?: string,
): Promise<string> => {
	const response = (await apiRequest(endpoints.saveSubmission.url, {
		method: endpoints.saveSubmission.requestMethod,
		body: JSON.stringify({
			data,
			...(uuid ? { uuid } : {}),
		}),
	})) as SaveSubmissionResponse;

	const savedUuid = response.data?.uuid?.trim() ?? "";
	if (!savedUuid) {
		throw new Error("Save succeeded but no result ID was returned.");
	}

	return savedUuid;
};

export const loadSubmission = async (
	uuid: string,
): Promise<{ uuid: string; payload: SavedSubmissionPayload }> => {
	const response = (await apiRequest(endpoints.loadSubmission.url, {
		method: endpoints.loadSubmission.requestMethod,
		body: JSON.stringify({ uuid }),
	})) as LoadSubmissionResponse;

	const data = response.data?.data;
	const loadedUuid = response.data?.uuid?.trim() || uuid.trim();
	if (!data || typeof data !== "object" || !data.formData) {
		throw new Error("Saved results could not be loaded.");
	}

	return {
		uuid: loadedUuid,
		payload: {
			formData: data.formData,
			chartData: data.chartData ?? null,
			seriesView: data.seriesView,
		},
	};
};
